import * as types from '../constants/ActionTypes';

const companyMulti = (
  state = {
    companies: [],
    percentNegative: null,
    percentNegativeChange: null,
    starRating: null,
    starRatingChange: null,
    totalResponses: null,
    trendMetrics: {},
    isLoading: false,
    error: false,
  },
  action
) => {
  switch (action.type) {
    case types.COMPANY_MULTI_REQUEST: {
      return Object.assign({}, state, { isLoading: true });
    }
    case types.COMPANY_MULTI_ERROR: {
      return Object.assign({}, state, { isLoading: false, error: true });
    }
    case types.COMPANY_MULTI_SUCCESS: {
      return Object.assign({}, state, action.multi, { isLoading: false });
    }
    default: {
      return state;
    }
  }
};

export default companyMulti;
